import axios from 'axios';
// import router from '../routerManuaConfig'
import router from '../router/index'
import store from "../store";
import Vue from 'vue';

let base = '/qmxfwebapi';
// let base = '';

// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
//let base = process.env.NODE_ENV=="production"? 'http://api.training.wanghuolou.cn:82':'';
//let base = process.env.NODE_ENV=="production"? 'http://192.168.1.4:5001':'';
//let base = process.env.NODE_ENV=="production"? 'http://192.168.1.4:1004':'';

// 请求延时
axios.defaults.timeout = 600000

var storeTemp = store;
axios.interceptors.request.use(
    config => {
        var curTime = new Date()
        var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))
        // if (storeTemp.state.token && (curTime < expiretime && storeTemp.state.tokenExpire)) {
        if (storeTemp.state.token) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = "Bearer " + storeTemp.state.token;
        }
        saveRefreshtime();
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
// http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.status == 401) {
            var curTime = new Date()
            var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
            // 在用户操作的活跃期内
            if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
                return refreshToken({ token: window.localStorage.Token }).then((res) => {
                    if (res.success) {
                        store.commit("saveToken", res.response.token);
                        var curTime = new Date();
                        var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expiresIn));
                        store.commit("saveTokenExpire", expiredate);
                        error.config.__isRetryRequest = true;
                        error.config.headers.Authorization = 'Bearer ' + res.response.token;
                        return axios(error.config);
                    } else {
                        ToLogin()
                        return false;
                    }
                })
                    .catch((err) => {
                        ToLogin()
                        return false;
                    })
            } else {
                ToLogin()
                return false;
            }
        } else if (response.data.status == 403) {
            Vue.prototype.$message({
                message: '失败！该操作无权限',
                type: 'error'
            });
            return null;
        } else if (response.data.status == 429) {
            Vue.prototype.$message({
                message: '刷新次数过多，请稍事休息重试！',
                type: 'error'
            });
            return null;
        } else if (response.data.status == 500) {
            setTimeout(function () {
                Vue.prototype.$message({
                    message: '服务器错误，请稍后重试！',
                    type: 'error'
                });
            }, 1000)
            return null;
        }
        return response;
    },
    error => {
        // 超时请求处理
        var originalRequest = error.config;
        console.log(error.config)
        if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {
            Vue.prototype.$message({
                message: '请求超时！',
                type: 'error'
            });
            originalRequest._retry = true
            return null;
        }
        if (error.response) {
            if (error.response.status == 401) {
                var curTime = new Date()
                var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
                // 在用户操作的活跃期内
                if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
                    return refreshToken({ token: window.localStorage.Token }).then((res) => {
                        if (res.success) {
                            // Vue.prototype.$message({
                            //     message: 'refreshToken success! loading data...',
                            //     type: 'success'
                            // });
                            store.commit("saveToken", res.response.token);
                            var curTime = new Date();
                            var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expiresIn));
                            store.commit("saveTokenExpire", expiredate);
                            error.config.__isRetryRequest = true;
                            error.config.headers.Authorization = 'Bearer ' + res.response.token;
                            return axios(error.config);
                        } else {
                            // 刷新token失败 清除token信息并跳转到登录页面
                            ToLogin()
                            return false;   //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
                        }
                    });
                } else {
                    // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
                    ToLogin()
                    return false;   //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
                }
            }
            // 403 无权限
            if (error.response.status == 403) {
                Vue.prototype.$message({
                    message: '失败！该操作无权限',
                    type: 'error'
                });
                return null;
            }
            // 429 ip限流
            if (error.response.status == 429) {
                Vue.prototype.$message({
                    message: '刷新次数过多，请稍事休息重试！',
                    type: 'error'
                });
                return null;
            }
            // 500
            if (error.response.status == 500) {
                setTimeout(function () {
                    Vue.prototype.$message({
                        message: '服务器错误，请稍后重试！',
                        type: 'error'
                    });
                }, 1000)
                return null;
            }
        }
        return ""; // 返回接口返回的错误信息
    }
);
const ToLogin = params => {
    store.commit("saveToken", "");
    store.commit("saveTokenExpire", "");
    store.commit("saveTagsData", "");
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('NavigationBar');
    var routerGo = router.currentRoute.fullPath.substring(0, 6)
    if (routerGo == "/login") {
    } else {
        router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath }
        });
    }
    // router.replace({
    //     path: "/login",
    //     query: {redirect: router.currentRoute.fullPath}
    // });
    // 调试登录过期后重新登录第一次无法跳转到相应的页面，而是停留在登录页面，所以暂时注释，怀疑重新加载所以看不到console.log("redirect_api--") date:2020-12-23
    window.location.reload()
    return false;  //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
};
export const BaseApiUrl = base;
export const saveRefreshtime = params => {
    let nowtime = new Date();
    let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1);
    let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))
    let refreshCount = 1;//滑动系数
    if (lastRefreshtime >= nowtime) {
        lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
        lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
        window.localStorage.refreshtime = lastRefreshtime;
    } else {
        window.localStorage.refreshtime = new Date(-1);
    }
};

// 系统登录
export const requestLogin = params => {
    return axios.get(`${base}/login/loginUser`, { params: params }).then(res => res.data);
};

//AI系统登录
export const aiDoLogin = params => {
    return axios.get(`${base}/login/aiDoLogin`, { params: params });
};
export const captchaImage = params => {
    return axios.get(`${base}/captcha/captchaImage`, { params: params }).then(res => res.data);
};

// 获取登录短信验证码
export const getLoginCode = params => {
    return axios.get(`${base}/login/getLoginCode`, { params: params }).then(res => res.data);
};

// 短信验证码登录
export const codelogin = params => {
    return axios.get(`${base}/login/codelogin`, { params: params }).then(res => res.data);
};

//刷新token
export const refreshToken = params => {
    return axios.get(`${base}/login/refreshToken`, { params: params }).then(res => res.data);
};

// ==============================首页接口STAR======================================================================


//系统管理
//用户管理
export const getUserListPage = params => {
    return axios.get(`${base}/userInfo/getUserInfoListPage`, { params: params });
};

// 根据token获取用户详细信息
export const getUserByToken = params => {
    return axios.get(`${base}/userInfo/getUserInfoByToken`, { params: params }).then(res => res.data);
};

//新增用户信息
export const addUserInfo = params => {
    return axios.post(`${base}/userInfo/addUserInfo`, params);
};

//更新用户信息
export const updateUserInfo = params => {
    return axios.post(`${base}/userInfo/updateUserInfo`, params);
};

//删除用户信息
export const deleteUserInfo = params => {
    return axios.delete(`${base}/userInfo/deleteUserInfo`, { params });
};

//发送修改密码手机短信验证码
export const sendModifyPasswordSMSVerificationCode = params => {
    return axios.post(`${base}/SystemManager/SendModifyPasswordSMSVerificationCode`, params);
};

//修改用户登录密码
export const modifyUserPassword = params => {
    return axios.post(`${base}/userInfo/modifyUserPassword`, params);
};

//系统管理
//菜单权限管理

//根据用户ID获取路由树
export const getNavigationBar = params => {
    return axios.get(`${base}/menuPermissions/getNavigationBar`, { params: params }).then(res => res.data);
};

//获取菜单树
export const getMenuTree = params => {
    return axios.get(`${base}/menuPermissions/getMenuTree`, { params: params });
};

//获取菜单权限树形列表
export const getMenuPermissionsTree = params => {
    return axios.get(`${base}/menuPermissions/getMenuPermissionsTree`, { params: params });
};

//新增菜单权限信息
export const addMenuPermissionsInfo = params => {
    return axios.post(`${base}/menuPermissions/addMenuPermissionsInfo`, params);
};

//更新菜单权限信息
export const updateMenuPermissionsInfo = params => {
    return axios.post(`${base}/menuPermissions/updateMenuPermissionsInfo`, params);
};


//删除菜单权限信息
export const deleteMenuPermissionsInfo = params => {
    return axios.delete(`${base}/menuPermissions/deleteMenuPermissionsInfo`, { params: params });
};

//保存菜单权限分配
export const assignMenuPermissions = params => {
    return axios.post(`${base}/menuPermissions/assignMenuPermissions`, params);
};

//通过角色获取菜单【无权限】
export const GetAssignMenuPermissionIdByRoleId = params => {
    return axios.get(`${base}/menuPermissions/getAssignMenuPermissionIdByRoleId`, { params: params });
};

//系统管理
//角色管理

//根据组织结构ID获取角色信息集合
export const getRoleInfosByOrganizationInfoID = params => {
    return axios.get(`${base}/roleInfo/getRoleInfoByName`, { params: params });
};

//获取角色信息分页列表
export const getRoleListPage = params => {
    return axios.get(`${base}/roleInfo/getRoleInfoListPage`, { params: params });
};

//新增角色信息
export const addRoleInfo = params => {
    return axios.post(`${base}/roleInfo/addRoleInfo`, params);
};

//更新角色信息
export const updateRoleInfo = params => {
    return axios.post(`${base}/roleInfo/updateRoleInfo`, params);
};

//删除角色信息
export const deleteRoleInfo = params => {
    return axios.delete(`${base}/roleInfo/deleteRoleInfo`, { params: params });
};


// 省市区
export const getAreaDictionaryList = params => {
    return axios.get(`${base}/areaCity/getAreaCityList`, { params: params });
};

//系统管理
// 部门管理

//获取组织结构树
export const getOrganizationTree = params => {
    return axios.get(`${base}/departmentInfo/getDepartmentTree`, { params: params });
};

//新增组织结构信息
export const addOrganizationInfo = params => {
    return axios.post(`${base}/departmentInfo/addDepartmentInfo`, params);
};

//更新组织结构信息
export const updateOrganizationInfo = params => {
    return axios.post(`${base}/departmentInfo/updateDepartmentInfo`, params);
};

//删除组织结构信息
export const deleteOrganizationInfo = params => {
    return axios.delete(`${base}/departmentInfo/deleteDepartmentInfo`, { params: params });
};

//系统管理
// 接口管理

//获取接口信息树形列表
export const getApiModulesInfoTree = params => {
    return axios.get(`${base}/apiModulesInfo/getApiModulesInfoTree`, { params: params });
};

//获取接口菜单树
export const getApiMenuTree = params => {
    return axios.get(`${base}/apiModulesInfo/getApiMenuTree`, { params: params });
};

//新增接口信息
export const addApiModulesInfo = params => {
    return axios.post(`${base}/apiModulesInfo/addApiModulesInfo`, params);
};

//更新接口信息
export const updateApiModulesInfo = params => {
    return axios.post(`${base}/apiModulesInfo/updateApiModulesInfo`, params);
};

//删除接口信息
export const deleteApiModulesInfo = params => {
    return axios.delete(`${base}/apiModulesInfo/deleteApiModulesInfo`, { params: params });
};

//系统管理
// 数据权限管理

//获取全部数据权限信息列表
export const getAllDataPermissionsInfoList = params => {
    return axios.get(`${base}/dataPermissionsInfo/getAllDataPermissionsInfoList`, { params: params });
};

//新增数据权限信息
export const addDataPermissionsInfo = params => {
    return axios.post(`${base}/dataPermissionsInfo/addDataPermissionsInfo`, params);
};

//更新数据权限信息
export const updateDataPermissionsInfo = params => {
    return axios.post(`${base}/dataPermissionsInfo/updateDataPermissionsInfo`, params);
};

//删除数据权限信息
export const deleteDataPermissionsInfo = params => {
    return axios.delete(`${base}/dataPermissionsInfo/deleteDataPermissionsInfo`, { params });
};

//保存数据权限分配
export const assignDataPermissions = params => {
    return axios.post(`${base}/dataPermissionsInfo/assignDataPermissions`, params);
};

//通过角色ID获取数据权限菜单【无权限】
export const getAssignDataPermissionIdByRoleId = params => {
    return axios.get(`${base}/dataPermissionsInfo/getAssignDataPermissionIdByRoleId`, { params: params });
};

export const getNotificationWebSiteUnReadCount = params => {
    return axios.get(`${base}/notificationWebsite/getNotificationWebsiteUnReadCount`, { params: params });
};

//产品管理
//产品分页列表
export const getProductListPage = params => {
    return axios.get(`${base}/productManage/getProductListPage`, { params: params });
}
export const getByDataCode = params => {
    return axios.get(`${base}/baseDictionary/getByDataCode`, { params: params });
}
export const getVideoUploadParams = params => {
    return axios.get(`${base}/fileManage/getVideoUploadParams`, { params: params });
}
//新增产品信息
export const addProductData = params => {
    return axios.post(`${base}/productManage/addProductData`, params);
}
//上传视频返回id
export const addFileByCode = params => {
    return axios.post(`${base}/fileManage/addFileByCode`, params);
}
//上传图片
//上传图片
export const uploadTempPic = `${base}/obs/uploadProductCover`
//根据条件筛选产品列表
export const getProductList = params => {
    return axios.get(`${base}/productManage/getProductList`, { params: params });
}
//新增产品合集
export const addProductCompilationsData = params => {
    return axios.post(`${base}/productManage/addProductCompilationsData`, params);
}
//获取产品合集列表
export const getProductCompilationsListPage = params => {
    return axios.get(`${base}/productManage/getProductCompilationsListPage`, { params: params });
}
//根据产品ID获取产品信息
export const getProductIdListData = params => {
    return axios.get(`${base}/productManage/getProductIdListData`, { params: params });
}

//根据合集产品Id获取产品信息
export const getProductCompilationsIdListData = params => {
    return axios.get(`${base}/productManage/getProductCompilationsIdListData`, { params: params });
}


//获取原始作者列表
export const getUserInfoList = params => {
    return axios.get(`${base}/userInfo/getUserInfoList`, { params: params });
}
//根据主题文件Id获取附件
export const getProductIdFileListAttachmentData = params => {
    return axios.get(`${base}/productManage/getProductIdFileListAttachmentData`, { params: params });
}
//根据附件Id删除附件
export const deleteProductFileIdAttachment = params => {
    return axios.get(`${base}/productManage/deleteProductFileIdAttachment`, { params: params });
}
//编辑产品信息
export const updateProductData = params => {
    return axios.post(`${base}/productManage/updateProductData`, params);
}
//删除单品
export const deleteProductId = params => {
    return axios.get(`${base}/productManage/deleteProductId`, { params: params });
}
//删除产品合集
export const deleteProductCompilationsId = params => {
    return axios.get(`${base}/productManage/deleteProductCompilationsId`, { params: params });
}
//编辑合集产品信息
export const updateProductCompilationsData = params => {
    return axios.post(`${base}/productManage/updateProductCompilationsData`, params);
}
//根据产品文件ID变更价格和状态
export const updateProductFilePrice = params => {
    return axios.post(`${base}/productManage/updateProductFilePrice`, params);
}
//根据产品id置顶产品
export const updateProductIdTop = params => {
    return axios.get(`${base}/productManage/updateProductTop`, { params: params });
}
//根据产品id发布产品
export const updateProductStatus = params => {
    return axios.get(`${base}/productManage/updateProductStatus`, { params: params });
}
//根据合集id置顶合集
export const updateProductCompilationsTop = params => {
    return axios.get(`${base}/productManage/updateProductCompilationsTop`, { params: params });
}
//根据合集id发布合集
export const updateProductCompilationsStatus = params => {
    return axios.get(`${base}/productManage/updateProductCompilationsStatus`, { params: params });
}

//获取题库试题分页列表
export const getExaminationQuestionsListPage = params => {
    return axios.get(`${base}/questionsManage/getExaminationQuestionsListPage`, { params: params });
}
// 批量导入试题
export const importExaminationQuestionsApi =`${base}/questionsManage/importExaminationQuestions`

//产品关联试题
export const addProductQuestionsRelationApi = params => {
    return axios.get(`${base}/questionsManage/addProductQuestionsRelation`, { params: params });
}
//产品取消关联试题
export const deleteProductQuestionsRelationApi = params => {
    return axios.delete(`${base}/questionsManage/deleteProductQuestionsRelation`, { params: params });
}
//上传文件到本地
export const uploadProductDownloadFile = params => {
    return axios.post(`${base}/obs/uploadProductDownloadFile`, params);
}

//获取小程序消息通知列表
export const getAppMessageListPage = (params) => {
    return axios.get(`${base}/userQmxfBackgroundMessageManage/getAppMessageListPage`, { params: params });
}
//新增小程序消息通知
export const addAppMessage = params => {
    return axios.post(`${base}/userQmxfBackgroundMessageManage/addAppMessage`, params);
};
//发送小程序消息通知
export const sendAppMessage = params => {
    return axios.get(`${base}/userQmxfBackgroundMessageManage/sendAppMessage`, { params: params });
};

//获取用户反馈列表
export const getAppProblemListPage = (params) => {
    return axios.get(`${base}/userQmxfBackgroundMessageManage/getAppProblemListPage`, { params: params });
}
//添加用户反馈回复
export const addAppProblemReply = params => {
    return axios.post(`${base}/userQmxfBackgroundMessageManage/addAppProblemReply`, params);
}
// 统计分析
// 统计分析/获取用户统计汇总数量
export const getUserQmxfDataListPageCountAll = params => {
    return axios.get(`${base}/statisticUser/getUserQmxfDataListPageCountAll`, { params: params });
}
// 统计分析/获取用户统计列表
export const getUserQmxfDataListPageCount = params => {
    return axios.get(`${base}/statisticUser/getUserQmxfDataListPageCount`, { params: params });
}

//统计分析/获取用户统计列表导出excel
export const exportUserQmxfDataListPageCountApi = params => {
    return axios.get(`${base}/statisticUser/getUserQmxfDataCountListExcel`, {params: params,responseType: "blob"} );
}

// 统计分析/获取用户明细列表
export const getUserProfile = params => {
    return axios.get(`${base}/statisticUser/getUserQmxfDataListPage`, { params: params });
}

//统计分析/获取用户明细列表导出excel
export const exportUserProfileApi = params => {
    return axios.get(`${base}/statisticUser/getUserQmxfDataListExcel`, {params: params,responseType: "blob"} );
}

// 统计分析/获取用户明细详情
export const getUserProfileDetails = params => {
    return axios.get(`${base}/statisticUser/getUserQmxfDataDetail`, { params: params });
}

// 推广营销
// 推广营销/促销活动设置/获取促销活动设置列表
export const getPromotionSettingsListApi = params => {
    return axios.get(`${base}/promotion/getPromotionPageListByKeyWord`, { params: params });
}
// 推广营销/促销活动设置/新增促销活动设置
export const addPromotionSettingsApi = params => {
    return axios.post(`${base}/promotion/addPromotion`, params);
}

// 推广营销/促销活动设置/更新促销活动设置
export const editPromotionSettingsApi = params => {
    return axios.post(`${base}/promotion/updatePromotion`, params);
}

// 推广营销/促销活动设置/更新促销活动状态
export const updatePromotionStatus = params => {
    return axios.get(`${base}/promotion/updatePromotionStatus`, { params: params });
}

// 推广营销/促销活动设置/获取促销活动更新记录列表
export const getPromotionUpdateRecordListApi = params => {
    return axios.get(`${base}/promotion/getPromotionUpdateRecordListByPromotionId`, { params: params });
}



// 推广营销/手机号码库管理/获取号码库列表
export const getPhoneNumberListApi = params => {
    return axios.get(`${base}/numberController/getNumberLibraryListPage`, { params: params });
}

// 推广营销/手机号码库管理/添加号码库
export const addPhoneNumberApi = params => {
    return axios.post(`${base}/numberController/addNumberLibrary`, params);
}

// 推广营销/手机号码库管理/编辑号码库
export const editPhoneNumberApi = params => {
    return axios.patch(`${base}/numberController/updateNumberLibrary`, params);
}

//推广营销/手机号码库管理/获取号码库里号码列表
export const getPhoneNumberDetailListApi = params => {
    return axios.get(`${base}/numberController/getNumberLibraryDetailListPage`, { params: params });
}

// 推广营销/手机号码库管理/导入号码库excel模板
export const addNumberLibraryDetailApi =`${base}/numberController/addNumberLibraryDetail`



//推广营销/短信模板通知/获取短信模板分页列表
export const getNoticeTemplateListPageApi = params => {
    return axios.get(`${base}/notificeTemplate/getNotificationTemplateListPage`, { params: params });
}

//推广营销/短信模板通知/新增短信通知模板
export const addNoticeTemplateApi = params => {
    return axios.post(`${base}/notificeTemplate/addNotificationTemplate`, params);
}

//推广营销/短信模板通知/更新短信通知模板
export const updateNoticeTemplateApi = params => {
    return axios.patch(`${base}//notificeTemplate/updateNotificationTemplate`, params);
}
//推广营销/短信模板通知/删除短信通知模板
export const delNoticeTemplateApi = params => {
    return axios.delete(`${base}/notificeTemplate/deleteNotificationTemplate`, { params: params });
}
//推广营销/短信模板/获取全部固定文本分页列表
// export const getSmsTemplateFixedListAllApi = params => {
//     return axios.get(`${base}/notificeTemplate/getSmsTemplateFixedList`, { params: params });
// }

//推广营销/短信模板/获取固定文本分页列表
export const getSmsTemplateFixedListApi = params => {
    return axios.get(`${base}/notificeTemplate/getSmsTemplateFixedListPage`, { params: params });
}
//推广营销/短信模板/添加固定文本
export const addSmsTemplateFixedApi = params => {
    return axios.post(`${base}/notificeTemplate/addSmsTemplateFixed`, params);
}
//推广营销/短信模板/删除固定文本
export const delSmsTemplateFixedApi = params => {
    return axios.delete(`${base}/notificeTemplate/deleteSmsTemplateFixed`, { params: params });
}
//推广营销/短信模板/修改固定文本
export const updateSmsTemplateFixedApi = params => {
    return axios.patch(`${base}/notificeTemplate/updateSmsTemplateFixed`, params);
}
//推广营销/区域营销管理/获取产品区域推广订单列表
export const getOrderProductPromotionListPageApi = params => {
    return axios.get(`${base}/orderInfoMange/getOrderProductPromotionListPage`, { params: params });
}
//推广营销/区域营销管理/添加产品区域推广订单
export const addOrderProductPromotionListPageApi = params => {
    return axios.post(`${base}/orderInfoMange/addOrderProductPromotion`, params);
}
//推广营销/区域营销管理/修改产品区域推广订单
export const editOrderProductPromotionListPageApi = params => {
    return axios.post(`${base}/orderInfoMange/updateOrderProductPromotion`, params);
}
//推广营销/区域营销管理/删除产品区域推广订单
export const delOrderProductPromotionListPageApi = params => {
    return axios.delete(`${base}/orderInfoMange/deleteOrderProductPromotion`, {params:params});
}
//推广营销/区域营销管理/产品区域推广订单是否启用
export const isEnablelOrderProductPromotionApi = params => {
    return axios.get(`${base}/orderInfoMange/updateOrderProductPromotionIsEnable`, { params: params });
}

//推广营销/区域营销管理/获取产品区域推广订单用户明细列表
export const getOrderProductPromotionListDetailPageApi = params => {
    return axios.get(`${base}/orderInfoMange/getOrderProductPromotionLogListPage`, { params: params });
}
//推广营销/区域营销管理/获取产品区域推广订单用户明细列表导出excel
export const exportOrderProductPromotionListDetailExcelApi = params => {
    return axios.get(`${base}/orderInfoMange/getOrderProductPromotionLogListExcel`, {params: params,responseType: "blob"} );
}

//推广营销/区域营销管理/获取区域订单周报
export const getOrderProductPromotionReportDataApi = params => {
    return axios.get(`${base}/orderInfoMange/getOrderProductPromotionReportData`, { params: params });
}

//推广营销/区域营销管理/访问区域推广订单报告
export const getOrderProductPromotionReportApi = params => {
    return axios.get(`${base}/obs/getOrderProductPromotionReport/${params}`,{ responseType: "blob" });
}

//推广营销/短信群发任务管理/获取短信群发任务管理列表
export const getSmsNotificationTaskListPageApi = params => {
    return axios.get(`${base}/numberController/getSmsNotificationTaskListPage`, {params: params} );
}

//推广营销/短信群发任务管理/添加短信群发任务
export const addSmsNotificationTaskApi = params => {
    return axios.post(`${base}/numberController/addSmsNotificationTask`, params);
}

//推广营销/短信群发任务管理/修改短信群发任务
export const editSmsNotificationTaskApi = params => {
    return axios.patch(`${base}/numberController/updateSmsNotificationTask`, params);
}

//推广营销/短信群发任务管理/修改短信群发任务审核状态
export const updateSmsNotificationTaskAuditStatusApi = params => {
    return axios.patch(`${base}/numberController/updateSmsNotificationTaskAuditStatus`, params);
}

//推广营销/短信群发任务管理/获取短信群发任务管理列表
export const getSmsNotificationTaskDetailListPageApi = params => {
    return axios.get(`${base}/numberController/getSmsNotificationTaskDetailListPage`, {params: params} );
}



//订单管理
export const getOrderProductDeductListPage = (params) => {
    return axios.get(`${base}/orderInfoMange/getOrderProductDeductListPage`, { params: params });
}
//获取订单详情列表
export const getOrderProductDetailList = (params) => {
    return axios.get(`${base}/orderInfoMange/getOrderProductDetailList`, { params: params });
}
//上传轮播图图片
export const uploadCarouselAndMessage = `${base}/obs/uploadCarouselAndMessage`
//获取轮播图列表
export const getCarouselInformationList = (params) => {
    return axios.get(`${base}/carouseInfo/getCarouselInformationList`, { params: params });
}
//新增轮播图信息
export const addCarouselInformation = params => {
    return axios.post(`${base}/carouseInfo/addCarouselInformation`, params);
}
//更新轮播图信息
export const updateCarouselInformation = params => {
    return axios.post(`${base}/carouseInfo/updateCarouselInformation`, params);
}
//删除轮播图信息
export const deleteCarouselInformation = params => {
    return axios.get(`${base}/carouseInfo/deleteCarouselInformation`, { params: params });
}
//修改轮播图状态
export const updateCarouselInformationIsEnable = params => {
    return axios.patch(`${base}/carouseInfo/updateCarouselInformationIsEnable`, params);
}

//上传文档文件
export const uploadDocumentFile = `${base}/obs/uploadDocumentFile`

// 获取勋章列表
export const getMedalListApi = params => {
    return axios.get(`${base}/medal/getMedalConfigurationPage`, { params: params });
}
// 添加勋章数据
export const addMedalApi = params => {
    return axios.post(`${base}/medal/addMedalConfiguration`, params);
}
// 编辑勋章数据
export const editMedalApi = params => {
    return axios.post(`${base}/medal/updateMedalConfiguration`, params);
}
//删除勋章数据
export const delMedalApi = params => {
    return axios.delete(`${base}/medal/deleteMedalConfiguration`, { params: params });
}

// 获取勋章修改记录
export const getChangeMedalConfigurationListApi = params => {
    return axios.get(`${base}/medal/getChangeMedalConfiguration`, { params: params });
}
// 上传勋章图片
export const uploadMedalImg = `${base}/obs/uploadMedalImg`
//添加积分数据
export const addUserPoint = params => {
    return axios.post(`${base}/pointMange/addUserPoint`, params);
}
//获取积分数据列表
export const getPointList = params => {
    return axios.get(`${base}/pointMange/getPointList`, { params: params });
}
//删除积分数据
export const deleteUserPoint = params => {
    return axios.delete(`${base}/pointMange/deleteUserPoint`, { params: params });
}
//更新积分数据（保存）
export const updateUserPoint = params => {
    return axios.patch(`${base}/pointMange/updateUserPoint`, params);
}
///获取积分变更记录
export const getPointRecordList = params => {
    return axios.get(`${base}/pointMange/getPointRecordList`, { params: params });
}


//获取提成基础配置列表
export const getCommissionBasisList = params => {
    return axios.get(`${base}/commissionSettings/getCommissionBasisList`, { params: params });
}

//新增提成基础配置
export const addCommissionBasis = params => {
    return axios.post(`${base}/commissionSettings/addCommissionBasis`, params);
}
//更新提成基础配置
export const updateCommissionBasis = params => {
    return axios.patch(`${base}/commissionSettings/updateCommissionBasis `, params);
}
//删除提成基础配置
export const deleteCommissionBasis = params => {
    return axios.get(`${base}/commissionSettings/deleteCommissionBasis`, { params: params });
}

//获取提成规则列表
export const getUploadDocumentFile = params => {
    return axios.get(`${base}/obs/getUploadDocumentFile`, { params: params });
}
//获取提现配置列表
export const getWithdrawalConfigList = params => {
    return axios.get(`${base}/commissionSettings/getCommissionWithdrawBasisList`, { params: params });
}

//新增提现配置
export const addWithdrawalConfig = params => {
    return axios.post(`${base}/commissionSettings/addCommissionWithdrawBasis`, params);
}
//更新提现配置
export const updateWithdrawalConfig = params => {
    return axios.patch(`${base}/commissionSettings/updateCommissionWithdrawBasis`, params);
}
//删除提现配置
export const deleteWithdrawalConfig = params => {
    return axios.get(`${base}/withdrawalConfig/deleteWithdrawalConfig`, { params: params });
}

//获取大V阶梯收费配置列表
export const getCommissionAnchorLadderBasisList = params => {
    return axios.get(`${base}/commissionSettings/getCommissionAnchorLadderBasisList`, { params: params });
}

//新增大V阶梯收费配置
export const addCommissionAnchorLadderBasis = params => {
    return axios.post(`${base}/commissionSettings/addCommissionAnchorLadderBasis`, params);
}
//更新大V阶梯收费配置
export const updateCommissionAnchorLadderBasis = params => {
    return axios.patch(`${base}/commissionSettings/updateCommissionAnchorLadderBasis`, params);
}
//删除大V阶梯收费配置
export const deleteCommissionAnchorLadderBasis = params => {
    return axios.get(`${base}/commissionSettings/deleteCommissionAnchorLadderBasis`, { params: params });
}
//获取用户提现统计分页列表
export const getWebUserQmxfWithdrawRecordsListPageCount = params => {
    return axios.get(`${base}/statisticCommission/getWebUserQmxfWithdrawRecordsListPageCount`, { params: params });
}
//获取提现汇总
export const getWithdrawSummary = params => {
    return axios.get(`${base}/statisticCommission/getWithdrawSummary`, { params: params });
}
//获取用户提现统计详情
export const getWebUserQmxfWithdrawRecordsListPage = params => {
    return axios.get(`${base}/statisticCommission/getWebUserQmxfWithdrawRecordsListPage`, { params: params });
}

//获取用户钱包统计分页列表
export const getWebUserQmxfWalletRecordsListPageCount = params => {
    return axios.get(`${base}/statisticCommission/getWebUserQmxfWalletRecordsListPageCount`, { params: params });
}

//获取钱包统计汇总
export const getWalletSummary = params => {
    return axios.get(`${base}/statisticCommission/getWalletSummary`, { params: params });
}

//获取用户钱包统计详情
export const getWebUserQmxfWalletRecordsListPage = params => {
    return axios.get(`${base}/statisticCommission/getWebUserQmxfWalletRecordsListPage`, { params: params });
}

//获取积分统计列表
export const getStatisticUserQmxfPointLogListDataPageCount = params => {
    return axios.get(`${base}/statisticPoint/getStatisticUserQmxfPointLogListDataPageCount`, { params: params });
}
//获取积分统计汇总
export const getPointSummary = params => {
    return axios.get(`${base}/statisticPoint/getPointSummary`, { params: params });
}


//获取积分统计详情
export const getStatisticUserQmxfPointLogListDataPage = params => {
    return axios.get(`${base}/statisticPoint/getStatisticUserQmxfPointLogListDataPage`, { params: params });
}

//运营统计/首页获取产品类统计
export const getHomeProductCount = params => {
    return axios.get(`${base}/homeCommission/getHomeProductCount`, { params: params });
}
export const getRegionalOrderCount = params => {
    return axios.get(`${base}/orderInfoMange/getRegionalOrderCount`, { params: params });
}
//运营统计/首页获取价格统计销售统计
export const getHomePriceAndSalesCount = params => {
    return axios.get(`${base}/homeCommission/getHomePriceAndSalesCount`, { params: params });
}

//运营统计/首页获取提现统计,大v统计,区域营销统计
export const getHomeCommissionAndBigVAndPromotionCount = params => {
    return axios.get(`${base}/homeCommission/getHomeCommissionAndBigVAndPromotionCount`, { params: params });
}

//运营统计/首页获取学习进度,功能类应用统计1和2
export const getHomeVideoAndPeopleAndClickCount = params => {
    return axios.get(`${base}/homeCommission/getHomeVideoAndPeopleAndClickCount`, { params: params });
}

//运营统计/首页获取订单优惠统计
export const getHomeOrderDiscountsCount = params => {
    return axios.get(`${base}/homeCommission/getHomeOrderDiscountsCount`, { params: params });
}



//日志管理
//日志管理/获取日志列表
export const getLoginLogList = params => {
    return axios.get(`${base}/log/getLogPageList`, { params: params });
}
// 产品热度分页列表
export const getUserProductPopularityStatisticsListPageApi = params => {
    return axios.get(`${base}/popularityStatistics/getUserProductPopularityStatistics`, { params: params });
}
// 产品热度页面汇总
export const getUserProductPopularityStatisticsCountApi = params => {
    return axios.get(`${base}/popularityStatistics/getUserProductPopularityStatisticsCount`, { params: params });
}
// 产品热度页面/播放明细分页
export const getUserProductWatchDetailApi = params => {
    return axios.get(`${base}/popularityStatistics/getUserProductWatchDetail`, { params: params });
}

// 产品热度页面/消费明细分页
export const getUserProductShoppingDetailApi = params => {
    return axios.get(`${base}/popularityStatistics/getUserProductShoppingDetail`, { params: params });
}

//转发统计分页列表
export const getProductShareClickerLogCountListPage = params => {
    return axios.get(`${base}/statisticShare/getProductShareClickerLogCountListPage`, { params: params });
}
//转发统计汇总
export const getShareSummary = params => {
    return axios.get(`${base}/statisticShare/getShareSummary`, { params: params });
}
//产品转发记录列表
export const getProductShareLogListPage = params => {
    return axios.get(`${base}/statisticShare/getProductShareLogListPage`, { params: params });
}
//分享链接点击记录列表
export const getProductShareClickerLogListPage = params => {
    return axios.get(`${base}/statisticShare/getProductShareClickerLogListPage`, { params: params });
}
//获取用户提成统计分页列表
export const getWebUserQmxfCommissionRecordsListPageCount = params => {
    return axios.get(`${base}/statisticCommission/getWebUserQmxfCommissionRecordsListPageCount`, { params: params });
}
//获取提成统计汇总
export const getCommissionSummary = params => {
    return axios.get(`${base}/statisticCommission/getCommissionSummary`, { params: params });
}

//获取用户提成统计详情
export const getWebUserQmxfCommissionRecordsListPage = params => {
    return axios.get(`${base}/statisticCommission/getWebUserQmxfCommissionRecordsListPage`, { params: params });
}
//获取大V用户列表
export const getUserDvPageList = params => {
    return axios.get(`${base}/userDv/getUserDvPageList`, { params: params });
}
//添加大V用户
export const addUserDv = params => {
    return axios.post(`${base}/userDv/addUserDv`, params);
}
//更新大V用户
export const updateUserDv = params => {
    return axios.post(`${base}/userDv/updateUserDv`, params);
}
//删除大V用户
export const deleteUserDv = params => {
    return axios.get(`${base}/userDv/deleteUserDv`, { params: params });
}
//更新大V用户状态
export const updateStatusById = params => {
    return axios.get(`${base}/userDv/updateStatusById`, { params: params });
}
//根据手机号获取用户信息
export const getUserByPhoneNumber = params => {
    return axios.get(`${base}/userDv/getUserByPhoneNumber`, { params: params });
}
// 获取区域订单用户观看统计
export const getOrderProductPromotionUserWatchStats = params => {
    return axios.get(`${base}/orderInfoMange/getOrderProductPromotionUserWatchStats`, { params: params });
}
// 获取区域订单用户观看统计(按年)
export const getOrderProductPromotionUserWatchStatsByYear = params => {
    return axios.get(`${base}/orderInfoMange/getOrderProductPromotionUserWatchStatsByYear`, { params: params });
}
// 获取区域订单用户性别统计
export const getOrderProductPromotionUserGenderStatistics = params => {
    return axios.get(`${base}/orderInfoMange/getOrderProductPromotionUserGenderStatistics`, { params: params });
}
// 获取区域订单学习进度分布
export const getOrderProductPromotionStudyProgress = params => {
    return axios.get(`${base}/orderInfoMange/getOrderProductPromotionStudyProgress`, { params: params });
}
// 获取区域订单产品Top10统计
export const getOrderProductPromotionProductTopTen = params => {
    return axios.get(`${base}/orderInfoMange/getOrderProductPromotionProductTopTen`, { params: params });
}








